import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './styles.css';
import { Avatar, Badge, Checkbox, Input, Switch, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Container from '../../components/Container/Container';
import { customerType, unitCaseEnum } from '../../utils/settings';
import {
  GetCompanyWiseInventoryData,
  GetProductWiseinventoryData,
} from '../../screen/distributor/action/util_action';
import FmcgProdCard from '../Components/FmcgProdCard';
import { useNavigate } from 'react-router-dom';
import NewContainer from '../../components/Container/newContainer';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { Button } from '@mui/material';

const DummyCO = [
  {
    company_id: 288311,
    company_name: 'Welspun Shield TMT',
    company_logo:
      'https://finalcompanylogos.s3.ap-south-1.amazonaws.com/bcm/tmt/Welspun+Shield.png',
    multiplier: 1000,
    quantity_in_metric_ton: 292.87,
    quantity_in_bags: 292870,
    quantity: 292870,
    units: 'Ton',
    base_units: 'Kg',
    mrp: '',
    rlp: '200',
    is_inventory_homogeneous: true,
  },
  {
    company_id: 293612,
    company_name: 'GRAVITY FERROUS ERW',
    company_logo:
      'https://finalcompanylogos.s3.ap-south-1.amazonaws.com/bcm/erw/Garvity+ERW.png',
    multiplier: 1000,
    quantity_in_metric_ton: 0,
    quantity_in_bags: 0,
    quantity: 0,
    units: 'Ton',
    base_units: 'Kg',
    mrp: '',
    rlp: '200',
    is_inventory_homogeneous: true,
  },
];

const dummy_prod = [
  {
    product_logo:
      'https://finalcompanylogos.s3.ap-south-1.amazonaws.com/bcm/tmt/Welspun+Shield.png',
    company_id: 288344,
    product_id: 271,
    product_multiplier: 1000,
    product_name: '20 mm TMT Bar FE 550',
    quantity_in_metric_ton: 0.98,
    quantity_in_bags: 980,
    quantity: 980,
    units: 'Ton',
    base_units: 'Kg',
    mrp: 250,
    rlp: 200,
  },
];

function FmcgInventory() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const [isSellToBuyer, setIsSellToBuyer] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [companies, setCompanies] = useState([]);
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProductListData, setFilteredProductListData] = useState([]);

  console.log('products', products);

  const { skuMaster, unitCaseWise, isSellToBuyer, cartItemList } = useSelector(
    (state) => {
      return {
        skuMaster: state.orderReducer.skuMaster,

        // FmcgInventory
        unitCaseWise: state.fmcgReducer.unitCaseWise,
        isSellToBuyer: state.fmcgReducer.isSellToBuyer,
        cartItemList: state.fmcgReducer.cartItemList,
      };
    },
  );

  function toggleSellToBuyer(value) {
    dispatch({ type: 'FMCG_IS_SELL_TO_BUYER', data: value });
    // setIsSellToBuyer(value);
  }

  const inventoryDataCompanyWise = async () => {
    const { error, data } = await GetCompanyWiseInventoryData();

    console.log(data);
    if (!error) {
      setCompanies(data);

      const selected = data[0];
      if (selected.is_inventory_homogeneous) {
        dispatch({ type: 'FMCG_UNIT_CASE_WISE', data: unitCaseEnum['CASE'] });
      }

      dispatch({ type: 'SET_SELLER_ID', data: selected.company_id });
      setSelectedCompany(selected);
    }
  };

  useEffect(() => {
    inventoryDataCompanyWise();
  }, []);

  const onCoChange = (value) => {
    setSelectedCompany(value);
    if (value.is_inventory_homogeneous) {
      dispatch({ type: 'FMCG_UNIT_CASE_WISE', data: unitCaseEnum['CASE'] });
      dispatch({ type: 'SET_SELLER_ID', data: value.company_id });
    } else dispatch({ type: 'SET_SELLER_ID', data: value.company_id });
  };

  // Get Company Products
  const getProductInventory = async () => {
    // setLoad(true);
    const { error, data } = await GetProductWiseinventoryData({
      manufacturer_id: selectedCompany.company_id,
    });
    // setLoad(false);
    if (!error) {
      if (data.length > 0) setProducts(data[0].inventory_list);
      else setProducts([]);
    }
  };

  useEffect(() => {
    if (!selectedCompany?.company_id) return;

    getProductInventory();
  }, [selectedCompany]);

  // Toggle between Units and Cases
  const toggleUnits = (value) => {
    dispatch({
      type: 'CLEAR_CART',
    });

    dispatch({
      type: 'FMCG_UNIT_CASE_WISE',
      data: value ? unitCaseEnum['CASE'] : unitCaseEnum['UNIT'],
    });
  };

  const handleSearchInputChange = (text) => {
    const query = text;
    setSearchQuery(query);

    if (!query) return setFilteredProductListData([]);

    // Filter products based on search query
    const filtered = products.filter((product) =>
      product.product_info.product_name
        .toLowerCase()
        .includes(query.toLowerCase()),
    );
    setFilteredProductListData(filtered);
  };

  return (
    <div className='fmcgCtr'>
      <div className='fmcgRightSection'>
        <div className='result'>
          <Input
            style={{
              borderRadius: 5,
            }}
            placeholder='Search Product'
            onChange={(e) => handleSearchInputChange(e.target.value)}
          />
        </div>
        <div className='companyFilters'>
          <div className='filterSubSection companyCtr'>
            <p className='subSectionTitle'>companies</p>
            {companies.map((item) => (
              <div>
                <Checkbox
                  checked={selectedCompany?.company_id === item.company_id}
                  onChange={() => onCoChange(item)}
                >
                  {item.company_name}
                </Checkbox>
              </div>
            ))}
          </div>
          {/* <div className='filterSubSection'>categories</div> */}
        </div>
      </div>
      <div className='fmcgLeftSection'>
        <div className='fmcgHeader'>
          <div className='tabCtr'>
            {!selectedCompany.is_inventory_homogeneous && (
              <div className='tabInnerCtr'>
                <div
                  onClick={() => toggleSellToBuyer(false)}
                  className={`tab ${!isSellToBuyer && 'active-tab'}`}
                >
                  View My inventory
                </div>
                <div
                  onClick={() => toggleSellToBuyer(true)}
                  className={`tab ${isSellToBuyer && 'active-tab'}`}
                >
                  Sell to Buyer
                </div>
              </div>
            )}
          </div>
          <div className='switchCtr'>
            {selectedCompany.is_inventory_homogeneous ? (
              <Button
                variant='contained'
                sx={{ ml: 1, color: 'white' }}
                onClick={() =>
                  navigate('/fmcg/buyer-cart', {
                    state: {
                      selectedCompany,
                    },
                  })
                }
              >
                Contunue To Sell
              </Button>
            ) : (
              <>
                {isSellToBuyer && (
                  <Badge
                    color='red'
                    count={cartItemList.length}
                    offset={[0, 5]}
                  >
                    <Avatar
                      onClick={() => {
                        if (cartItemList.length === 0) return;
                        return navigate('/fmcg/buyer-cart');
                      }}
                      className='cartIcon'
                      icon={<ShoppingCartOutlined />}
                      shape='circle'
                      size='large'
                    />
                  </Badge>
                )}

                <Switch
                  onChange={toggleUnits}
                  checkedChildren={selectedCompany.unit}
                  unCheckedChildren={selectedCompany.base_unit}
                  checked={unitCaseWise === unitCaseEnum['CASE']}
                />
              </>
            )}
          </div>
        </div>
        <div
          className={`fmcgProductList ${
            isSellToBuyer && 'fmcgProductListDouble'
          }`}
        >
          {(filteredProductListData.length > 0
            ? filteredProductListData
            : products
          ).map((prod, index) => {
            const itemInCart = cartItemList.find(
              (item) =>
                item.product_info.product_id === prod.product_info.product_id,
            );
            return (
              <FmcgProdCard
                prod={prod}
                index={index}
                itemInCart={itemInCart}
                isHomogeneous={selectedCompany.is_inventory_homogeneous}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default FmcgInventory;
